import { NgModule } from "@angular/core";
import { SharedLibraryModule } from "apps-module/app/shared-library/shared-library.module";
import { PaginationComponent } from "apps-module/app/common-components/pagination/pagination.component";
import { SearchBarComponent } from "apps-module/app/common-components/search-bar/search-bar.component";
import { DropdownFilterComponent } from "apps-module/app/common-components/dropdown-filter/dropdown-filter.component";
import { DatePickerComponent } from "apps-module/app/common-components/date-picker/date-picker.component";
import { NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { SpinnerComponent } from "apps-module/app/common-components/spinner/spinner.component";

@NgModule({
    declarations: [
        SpinnerComponent,
        DatePickerComponent,
        PaginationComponent,
        SearchBarComponent,
        DropdownFilterComponent
    ],
    exports: [
        SpinnerComponent,
        DatePickerComponent,
        SharedLibraryModule,
        PaginationComponent,
        SearchBarComponent,
        DropdownFilterComponent
    ],
    imports: [
        NgbDatepickerModule,
        SharedLibraryModule
    ]
})
export class CommonComponentsModule { }
